/**
 * Theme configuration mapping each theme to its dark/light counterpart
 */
export const THEME_PAIRS: { [key: string]: string } = {
  // Bootstrap themes
  'bootstrap4-light-blue': 'bootstrap4-dark-blue',
  'bootstrap4-light-purple': 'bootstrap4-dark-purple',
  'bootstrap4-dark-blue': 'bootstrap4-light-blue',
  'bootstrap4-dark-purple': 'bootstrap4-light-purple',

  // Material Design themes
  'md-light-indigo': 'md-dark-indigo',
  'md-light-deeppurple': 'md-dark-deeppurple',
  'md-dark-indigo': 'md-light-indigo',
  'md-dark-deeppurple': 'md-light-deeppurple',

  // Material Design Compact themes
  'mdc-light-indigo': 'mdc-dark-indigo',
  'mdc-light-deeppurple': 'mdc-dark-deeppurple',
  'mdc-dark-indigo': 'mdc-light-indigo',
  'mdc-dark-deeppurple': 'mdc-light-deeppurple',

  // Lara themes (PrimeOne 2022)
  'lara-light-indigo': 'lara-dark-indigo',
  'lara-light-blue': 'lara-dark-blue',
  'lara-light-purple': 'lara-dark-purple',
  'lara-light-teal': 'lara-dark-teal',
  'lara-dark-indigo': 'lara-light-indigo',
  'lara-dark-blue': 'lara-light-blue',
  'lara-dark-purple': 'lara-light-purple',
  'lara-dark-teal': 'lara-light-teal',

  // PrimeOne 2021 Saga themes (light)
  'saga-blue': 'vela-blue',
  'saga-green': 'vela-green',
  'saga-orange': 'vela-orange',
  'saga-purple': 'vela-purple',

  // PrimeOne 2021 Vela themes (dark)
  'vela-blue': 'saga-blue',
  'vela-green': 'saga-green',
  'vela-orange': 'saga-orange',
  'vela-purple': 'saga-purple',

  // PrimeOne 2021 Arya themes (dark) - no light counterpart, map to saga
  'arya-blue': 'saga-blue',
  'arya-green': 'saga-green',
  'arya-orange': 'saga-orange',
  'arya-purple': 'saga-purple',

  // Single color themes - map to themselves (no counterpart)
  'tailwind-light': 'tailwind-light',
  'fluent-light': 'fluent-light',
};

/**
 * Get the opposite theme (dark if current is light, light if current is dark)
 * @param currentTheme The current theme name
 * @returns The opposite theme name, or the same theme if no opposite exists
 */
export function getOppositeTheme(currentTheme: string): string {
  return THEME_PAIRS[currentTheme] || currentTheme;
}

/**
 * Check if a theme is a dark theme
 * @param theme The theme name
 * @returns true if the theme is dark
 */
export function isDarkTheme(theme: string): boolean {
  return (
    theme.includes('-dark') ||
    theme.includes('vela-') ||
    theme.includes('arya-')
  );
}
